import React, { useEffect, useState } from "react";
import Layout from "../../components/Layout";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import ToastFile from "../../utils/ToastFile";
import { addTenant, updateTenant } from "../../api/TenantApi";

const AddUpdateTenant = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const [isActionEdit, setIsActionEdit] = useState(false);
  const user = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    if (state?.tenant) {
      setIsActionEdit(true);
      reset(state?.tenant);
    } else {
      setIsActionEdit(false);
    }
  }, []);

  const onSubmit = (data) => {
    let payload = {
      ...data,
      createdBy: user.user_id,
      createdAt: new Date(),
      modifiedBy: user.user_id,
      modifiedAt: new Date(),
    };
    if (isActionEdit) {
      updateTenant(state?.tenant?._id, payload)
        .then((res) => {
          if (res.status === 200) {
            ToastFile("Tenant updated successfully", "updated");
            setTimeout(() => {
              navigate("/tenants");
            }, 2000);
          } else {
            ToastFile("Failed to update tenant", "error");
          }
        })
        .catch((err) => {
          console.error("Error updating tenant:", err);
          ToastFile("Error updating tenant", "error");
        });
      reset();
      setIsActionEdit(false);
    } else {
      addTenant(payload)
        .then((res) => {
          if (res.status === 201) {
            ToastFile("Tenant added successfully", "added");
            setTimeout(() => {
              navigate("/tenants");
            }, 2000);
          } else {
            ToastFile("Failed to add tenant", "error");
          }
        })
        .catch((err) => {
          console.error("Error adding tenant:", err);
          ToastFile("Error adding tenant", "error");
        });
    }
  };

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  return (
    <Layout>
      <div className="p-3">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <span
            style={{
              fontSize: "22px",
              fontWeight: 600,
              minWidth: "140px",
            }}
          >
      {isActionEdit ? "Edit Tenant" : "Add Tenant"}
          </span>
        </div>

        <Form onSubmit={handleSubmit(onSubmit)}>
          <Form.Group className="mb-3">
            <Form.Label>Company Name</Form.Label>
            <Form.Control
              type="text"
              {...register("name", { required: true })}
              isInvalid={errors.name}
            />
          </Form.Group>
           <Form.Group className="mb-3">
            <Form.Label>Contact No</Form.Label>
            <Form.Control
              type="text"
              {...register("contact_no", { required: true })}
              isInvalid={errors.contact_no}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Address</Form.Label>
            <Form.Control
              type="text"
              {...register("address", { required: true })}
              isInvalid={errors.address}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Email</Form.Label>
            <Form.Control
              type="email"
              {...register("email", { required: true })}
              isInvalid={errors.email}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>ABN</Form.Label>
            <Form.Control
              type="text"
              {...register("abn", { required: false })}
              isInvalid={errors.slug}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Slug</Form.Label>
            <Form.Control
              type="text"
              {...register("slug", { required: false })}
              isInvalid={errors.slug}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Subscriptions Date</Form.Label>
            <Form.Control
              type="date"
              {...register("subscriptions_date", { required: false })}
              isInvalid={errors.subscriptions_date}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Status</Form.Label>
            <Form.Select
              {...register("status", { required: true })}
              isInvalid={errors.status}
            >
              <option value="">Select status</option>
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
            </Form.Select>
          </Form.Group>

          <Button variant="primary" type="submit">
            {isActionEdit ? "Update" : "Add"}
          </Button>
          <Button
            variant="white"
            className="border-1 border-dark ms-2"
            onClick={() => navigate("/tenants")}
          >
            Cancel
          </Button>
        </Form>
      </div>
    </Layout>
  );
};

export default AddUpdateTenant;
